/* import __COLOCATED_TEMPLATE__ from './learningmaterial-search.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { dropTask, enqueueTask, restartableTask } from 'ember-concurrency';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let LearningMaterialSearchComponent = (_class = class LearningMaterialSearchComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "query", _descriptor3, this);
    _initializerDefineProperty(this, "searchResults", _descriptor4, this);
    _initializerDefineProperty(this, "searchPage", _descriptor5, this);
    _initializerDefineProperty(this, "searchResultsPerPage", _descriptor6, this);
    _initializerDefineProperty(this, "hasMoreSearchResults", _descriptor7, this);
    _initializerDefineProperty(this, "searchReturned", _descriptor8, this);
    _defineProperty(this, "search", _buildTask(() => ({
      context: this,
      generator: function* (query) {
        if (query.trim() === '') {
          this.searchReturned = false;
          this.searchPage = 1;
          this.hasMoreSearchResults = false;
          this.searchResults = [];
          return;
        }
        this.searchReturned = false;
        this.query = query;
        const results = yield this.store.query('learning-material', {
          q: query,
          limit: this.searchResultsPerPage + 1,
          'order_by[title]': 'ASC'
        });
        const lms = results.slice();
        this.searchReturned = true;
        this.searching = false;
        this.searchPage = 1;
        this.hasMoreSearchResults = lms.length > this.searchResultsPerPage;
        if (this.hasMoreSearchResults) {
          lms.pop();
        }
        this.searchResults = lms;
      }
    }), null, "search", "restartable"));
    _defineProperty(this, "searchMore", _buildTask(() => ({
      context: this,
      generator: function* () {
        const results = yield this.store.query('learning-material', {
          q: this.query,
          limit: this.searchResultsPerPage + 1,
          offset: this.searchPage * this.searchResultsPerPage,
          'order_by[title]': 'ASC'
        });
        const lms = results.slice();
        this.searchPage = this.searchPage + 1;
        this.hasMoreSearchResults = lms.length > this.searchResultsPerPage;
        if (this.hasMoreSearchResults) {
          lms.pop();
        }
        this.searchResults = [...this.searchResults, ...lms];
      }
    }), null, "searchMore", "drop"));
    _defineProperty(this, "addLearningMaterial", _buildTask(() => ({
      context: this,
      generator: function* (lm) {
        if (!this.args.currentMaterialIds.includes(lm.id)) {
          yield this.args.add(lm);
        }
      }
    }), null, "addLearningMaterial", "enqueue"));
  }
  clear() {
    this.searchResults = [];
    this.searchReturned = false;
    this.searching = false;
    this.searchPage = 0;
    this.hasMoreSearchResults = false;
    this.query = '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "query", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchResults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "searchPage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "searchResultsPerPage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 50;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasMoreSearchResults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "searchReturned", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype), _class);
export { LearningMaterialSearchComponent as default };